import { Component } from '@angular/core';
import { NavController, NavParams, ModalController } from 'ionic-angular';
import * as Faker from "faker";

@Component( {
                selector: 'page-home',
                templateUrl: 'home.html'
            } )
export class HomePage {
    users: { name: string, image: string }[] = [];

    constructor(
        public navCtrl: NavController,
        private NavParams: NavParams,
        private ModalController: ModalController
    ) {
        for ( let x = 0; x < 50; x++ ) {
            this.users.push( {
                                 name: Faker.name.findName(),
                                 image: Faker.image.avatar()
                             } )
        }
    }

}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts